import {withTranslation} from "react-i18next";
import React from "react";
import variables from "../../../_constants/variables";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";


function Accountuser(props) {
    const {t, user, userProfile} =props;

    const storage = localOrSessionStore({key: variables.REMEMBER});
    const userType = storage.getItem(variables.USER_TYPE);
    return <div className={"cardStudent"}>
        {/* ToDo : Revisar carga de datos */}
        <div className={"itemCard itemCardHeader"}>{t("informes.card.title")}</div>
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("login.name")}:</div>
            <div className={"itemCardRight"}>{user.name} {user.surname}</div>
        </div>
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("registro.centro")}:</div>
            <div className={"itemCardRight"}>{userProfile?.center?.name}</div>
        </div>
        {/* ToDo : Poner año accademico automatico */}
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("yeara")}:</div>
            <div className={"itemCardRight"}>20{userProfile.year}/20{userProfile.year+1}</div>
        </div>
        {userType !== "COUNSELOR" &&
            <div className={"itemCard"}>
                <div className={"itemCardLeft"}>{t("login.course")}:</div>
                <div className={"itemCardRight"}>
                    {
                        userType === "TUTOR" ?
                            userProfile?.tutorgroups.map(item => {
                                return <div className={"itemCardRight"}
                                            key={item.id}>{item.course.name} ({t("login.group")} {item.group})</div>
                            })
                            :
                            userProfile?.course?.name}</div>
            </div>
        }
        { userType !== "TUTOR" &&  userType !== "COUNSELOR" &&
                <div className={"itemCard"}>
                    <div className={"itemCardLeft"}>{t("login.group")}:</div>
                    <div className={"itemCardRight"}>{userProfile?.group}</div>
                </div>
        }
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("informes.card.email")}:</div>
            <div className={"itemCardRight"}>{user.email}</div>
        </div>
    </div>

}


export default withTranslation()(Accountuser);
